import { AxiosError, AxiosResponse } from "axios";

import { EcommProduct } from "@/types/care";
import { getRequest } from "@/utils/axios";

const fetchAllProducts = async () => {
  const response = await getRequest(
    `/api/v1/products/all-products/`,
    (response: AxiosResponse) => {
      return response;
    },
    (error: AxiosError) => {
      throw error;
    }
  );
  return response;
};

/**
 * Fetch an EcommProduct by SKU
 */
const getEcommProductBySku = async (
  sku: string
): Promise<EcommProduct | null> => {
  try {
    const response = await getRequest(
      `/api/v1/ecomm-products/${sku}/`,
      (response: AxiosResponse) => response,
      (error: AxiosError) => {
        console.error(`Failed to fetch product with SKU ${sku}:`, error);
        throw error;
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch product with SKU ${sku}:`, error);
    return null;
  }
};

export const productsService = {
  fetchAllProducts,
  getEcommProductBySku,
};
